// extracted by mini-css-extract-plugin
export default {"fullWidth":"_o-z","image":"ap-z","lazyLoadPicture":"bp-z","lazyLoadSpinner":"cp-z","lazyLoadSpin":"dp-z","lazyLoadImage":"ep-z","hasStyledAspectRatio":"fp-z"};